import { render, staticRenderFns } from "./TracksDistributeView.vue?vue&type=template&id=6c5d5b11&"
import script from "./TracksDistributeView.vue?vue&type=script&lang=ts&"
export * from "./TracksDistributeView.vue?vue&type=script&lang=ts&"
import style0 from "./TracksDistributeView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports